import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export function useTrackCheckoutPayNowClicked() {
    return useTrackConversion({
        goal: KameleoonGoalData.CheckoutPayNowClicked,
    });
}
